import React, { useState } from "react";
//import ID from '../components/IdEntry';
//import Confirm from '../components/Confirm';
import { AddQueue } from '../components/LambdaApi.js';
import { useClient } from '../context/ClientContext.tsx';
import './checkinSimple.css';
import { useRef } from "react";
import { Link } from 'react-router-dom';

const Checkin = () => {

    const inputRef = useRef(null);

    const [confirmed, setConfirmed] = useState(0);

    const [stepCount, setStepCount] = useState(0);

    //const [clientCode, setClientCode] = useState("ABC School");
    const { name, organization } = useClient();
    const clientCode = organization;

    const entryMode = "Multiple"; //Single or Multiple

    function updateStepCount(event) {
        if (event.target.name === "back") {
            if (stepCount !== 0) {
                setStepCount(stepCount - 1);
            }
        }
        else {
            setStepCount(stepCount + 1);
            if (stepCount > 3) {
            }
        }
    }

    const [id, setId] = useState();


    function handleOnClick() {
        //AddQueue('{"userId":' + id + ',"id":'+ id +',"type":"' + type + '","color":"' + color + '"}')
        //AddQueue('{ "UserID":"' + id + '","Type":"","Color":"","IsDeleted":false }')
        //AddQueue('{ "ClientCode":"' + clientCode + '" , "StudentID":"' + id + '","Type":"","Color":"","IsDeleted":false }')
        AddQueue({
            ClientCode: clientCode,
            StudentID: id,
            Type: "",
            Color: "",
            IsDeleted: false
        })

        setConfirmed(1);
        if (inputRef.current) {
            inputRef.current.value = "";
            inputRef.current.focus();
        }
        setId(null);
    }

    function handleOnChange(event) {
        setId(event.target.value);
        setConfirmed(0);
    }


    return (
        <div className="Checkin">

            <div style={{
                position: 'absolute',
                top: 10,
                left: 10,
                zIndex: 1000
            }}>
                <Link style={{ color: 'white', fontSize: '18px' }} to="/">Home</Link>
            </div>

            <h1>
                Check-In Page.
            </h1>
            <h3>{organization}</h3>

            <div>

                {(confirmed === 1 && entryMode === "Single") ? <label>Submitted!</label> : <>

                    {(stepCount <= 0) ?
                        <div>
                            <h2>Enter Pickup ID.</h2>
                            <input type="number" autoComplete="new-password" inputMode="numeric" name="myInput" ref={inputRef} style={{ height: 50, width: 150, fontSize: 40 }} onChange={handleOnChange} />
                        </div>
                        : <></>}
                    {/* {(stepCount === 1) ? <Confirm id={id} /> : <></> }
                    {(stepCount > 1) ? <div style={{fontSize:40}}>Done</div> : <></> } */}

                    {(id) ?
                        <div>
                            <button style={{ height: 100, width: 200, fontSize: 40 }} onClick={handleOnClick}>Confirm</button>
                            <br></br>
                            <label>(click confirm to check-in)</label>
                        </div>
                        : <></>}

                    {(confirmed === 1 && entryMode === "Multiple") ? <label>Submitted!</label> : <></>}

                </>}

            </div>




        </div>
    );
};

export default Checkin;